import React, { useState, useRef, useEffect } from "react";
import SchoolHeader from "../school/header";
import TeacherHeader from "../teacher/header";
import SchoolTeacherHeader from "../schoolteacher/header";
import SchoolSidebar from "../school/sidebar";
import { Link, useSearchParams } from "react-router-dom";
import TeacherServices from "../../services/TeacherServices";
import VimeoPlayer from "../vimeo";
import QuizServices from "../../services/QuizServices";
import Swal from "sweetalert2";
const TeacherTest = () => {
  const [searchParams] = useSearchParams();

  const [apiResponse, setApiResponse] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [showQuestion, setShowQuestion] = useState(false);
  const [message, setMessage] = useState("");
  const [showReplay, setShowReplay] = useState(false);
  const videoRef = useRef(null);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [answerSelected, setAnswerSelected] = useState(false);
  const [showIsContinue, setShowIsContinue] = useState(false);
  const [isAfterVideoVimeo, setIsAfterVideoVimeo] = useState(false);
  const [afterVideoVimeoId, setAfterVideoVimeoId] = useState(null);
  const [retakeVideoId, setRetakeVideoId] = useState(null);
  const [isRetakeComplete, setIsRetakeComplete] = useState(false);
  var role = localStorage.getItem("userrole");

  // ✅ Fetch Videos Properly
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await TeacherServices.getVideosWithQuiz();
        console.log("API Response:", response);

        if (response && response.videos) {
          setApiResponse(response);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  useEffect(() => {
    const getRetakeVideoId = async () => {
      try {
        const videoId = Number(searchParams.get("video_id"));
        const quizLength = apiResponse.videos[0].quizzes.length;
        setRetakeVideoId(videoId);
        if (videoId) {
          setCurrentVideoIndex(videoId > quizLength - 1 ? 1 : 0);
          setCurrentGroupIndex(
            videoId >= quizLength ? videoId - quizLength : videoId
          );
        }
      } catch (error) {}
    };

    getRetakeVideoId();
  });

  useEffect(() => {
    const checkProcess = async () => {
      try {
        const response = await QuizServices.checkProcess();

        setShowIsContinue(
          response.currentGroupIndex !== 0 || response.currentVideoIndex !== 0
        );
        setCurrentGroupIndex(response.currentGroupIndex);
        setCurrentVideoIndex(response.currentVideoIndex);
      } catch (error) {
        console.error("Error getting process", error);
      }
    };
    searchParams.get("video_id") === null ? checkProcess() : "";
  }, []);

  // useEffect(() => {
  //   const disableLinks = (disable) => {
  //     document.querySelectorAll("a").forEach(link => {
  //       link.style.pointerEvents = disable ? "none" : "auto";
  //       link.style.color = disable ? "gray" : "";
  //     });
  //   };

  //   disableLinks(showQuestion);

  //   return () => disableLinks(false);
  // }, [showQuestion]);
  // useEffect(() => {
  //   const disableNavigation = () => {
  //     window.history.pushState(null, "", window.location.href);
  //   };

  //   if (showQuestion) {
  //     window.history.pushState(null, "", window.location.href);
  //     window.addEventListener("popstate", disableNavigation);
  //   } else {
  //     window.removeEventListener("popstate", disableNavigation);
  //   }

  //   return () => {
  //     window.removeEventListener("popstate", disableNavigation);
  //   };
  // }, [showQuestion]);

  // useEffect(() => {
  //   const blockActions = (event) => event.preventDefault();

  //   if (showQuestion) {
  //     document.addEventListener("contextmenu", blockActions);
  //     document.addEventListener("keydown", (event) => {
  //       if (event.ctrlKey && (event.key === "u" || event.key === "s" || event.key === "i" || event.key === "c")) {
  //         event.preventDefault();
  //       }
  //     });
  //   } else {
  //     document.removeEventListener("contextmenu", blockActions);
  //   }

  //   return () => {
  //     document.removeEventListener("contextmenu", blockActions);
  //   };
  // }, [showQuestion]);

  const enableLinks = () => {
    document.querySelectorAll("a").forEach((link) => {
      link.style.pointerEvents = "auto";
      link.style.color = "";
    });
  };
  // ✅ Keep Blocking Browser Navigation
  //   const disableNavigation = () => {
  //     history.pushState(null, "", location.href);
  // };
  // const blockActions = (event) => {
  //   event.preventDefault(); // Prevent default right-click and keyboard shortcuts
  // };
  const enableNavigation = () => {
    window.removeEventListener("popstate", disableNavigation);
  };

  const enableRightClickAndShortcuts = () => {
    document.removeEventListener("contextmenu", blockActions);
  };

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (!answerSelected) {
      setSelectedOptions({ [name]: true }); // Allow only one selection
      handleAnswer(name); // Check answer immediately
      setAnswerSelected(true); // Disable further selection
    }
  };
  // ✅ Get current video, group, and question
  const currentVideo = apiResponse?.videos?.[currentVideoIndex];
  //groups?.videos?.[currentVideoIndex];//
  const currentGroup = currentVideo?.quizzes?.[currentGroupIndex];
  const currentQuestion = currentGroup?.questions?.[currentQuestionIndex];
  const currentVideoVimeoId = currentGroup?.videoVimeoId?.trim();
  const currentvideotitle = currentGroup?.videoName;
  //alert(currentVideoVimeoId);
  const handleVideoEnd = async () => {
    setVideoPlayed(true);

    if (isAfterVideoVimeo) {
      setShowQuestion(false);
      await QuizServices.saveProcess(0, currentVideoIndex + 1);
      setCurrentVideoIndex(currentVideoIndex + 1);
      setCurrentGroupIndex(0);
      setCurrentQuestionIndex(0);
      setIsAfterVideoVimeo(false);
      setVideoPlayed(false);
      setShowQuestion(false);
    } else {
      setShowQuestion(true);
    }

    if (currentGroup?.questions.length === 0) {
      setQuizCompleted(true);

      await QuizServices.saveProcess(0, apiResponse.videos.length);
      // enableLinks();
      // enableNavigation();
      // enableRightClickAndShortcuts();

      try {
        const response = await QuizServices.completeProcess();
        console.log(response, "Quiz completion response");
      } catch (error) {
        // console.error("Error saving quiz info:", error);
        // // alert("Quiz already completed by you.");
        // Swal.fire({
        //   position: "top-end",
        //   icon: "info",
        //   title: "Oops...",
        //   text: "Quiz already completed by you.",
        // });
      }
    }
  };
  const handleAnswer = async (answer) => {
    if (!currentQuestion) return;

    if (answer === currentQuestion.correctAnswer) {
      setMessage("✅ Correct! Moving to the next question...");
      setTimeout(async () => {
        setMessage("");
        setAnswerSelected(false); // Re-enable checkboxes
        if (currentQuestionIndex + 1 < currentGroup.questions.length) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else if (currentGroupIndex + 1 < currentVideo.quizzes.length && searchParams.get("video_id")==null) {
          await QuizServices.saveProcess(
            currentGroupIndex + 1,
            currentVideoIndex
          );

          setCurrentGroupIndex(currentGroupIndex + 1);
          setCurrentQuestionIndex(0);
          setVideoPlayed(false);
          setShowQuestion(false);
        } else if (currentVideoIndex + 1 < apiResponse.videos.length && searchParams.get("video_id")==null) {
          // ✅ Fixed variable
          if (currentGroup?.afterVideoVimeoId) {
            setAfterVideoVimeoId(currentGroup?.afterVideoVimeoId.trim());
            setIsAfterVideoVimeo(true);
          } else {
            retakeVideoId && await QuizServices.saveProcess(0, currentVideoIndex + 1);
            setCurrentVideoIndex(currentVideoIndex + 1);
            setCurrentGroupIndex(0);
            setCurrentQuestionIndex(0);
            setIsAfterVideoVimeo(true);
          }
          setVideoPlayed(false);
          setShowQuestion(false);
        } else if (searchParams.get("video_id")==null){
          setQuizCompleted(true);
          // enableLinks();
          // enableNavigation();
          // enableRightClickAndShortcuts();

          try {
            const response = await QuizServices.completeProcess();
            console.log(response, "Quiz completion response");
          } catch (error) {
            // console.error("Error saving quiz info:", error);
            // // alert("Quiz already completed by you.");
            // Swal.fire({
            //   position: "top-end",
            //   icon: "info",
            //   title: "Oops...",
            //   text: "Quiz already completed by you.",
            // });
          }

          setMessage("🎉 Quiz Completed!");
        } else{
          setIsRetakeComplete(true);
        }
        setSelectedOptions({}); // Reset selected options
      }, 1000);
    } else {
      setMessage("❌ Incorrect! Please watch the video again.");
      setShowReplay(true);
    }
  };

  const handleReplay = () => {
    setShowReplay(false);
    setMessage("");
    setVideoPlayed(false);
    setShowQuestion(false);
    setAnswerSelected(false); // Reset answer selection
    if (videoRef.current) {
      videoRef.current.play();
    }
    setSelectedOptions({});
  };

  const handleRestartProcess = () => {
    setCurrentGroupIndex(0);
    setCurrentVideoIndex(0);
    setShowIsContinue(false);
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="header-container">
          {role == 1 && <SchoolHeader activeMenu={"Dashboard"} />}
          {role == 2 && <SchoolTeacherHeader activeMenu={"Dashboard"} />}
          {role == 3 && <TeacherHeader activeMenu={"Dashboard"} />}
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* <SchoolSidebar /> */}
              <div className="col-xl-12 col-lg-12">
                <div className="row justify-content-center">
                  <div className="dashboard-title">
                    <h2>{currentvideotitle || "Loading Video..."}</h2>
                    <p>
                      {currentvideotitle ==
                      "Congratulations on Completing Your Course"
                        ? " "
                        : currentVideo?.description || ""}
                    </p>
                  </div>
                  <div className="col-lg-12 col-md-12 d-flex">
                    <div className="card dash-info flex-fill">
                      <div className="card-body">
                        {!videoPlayed && currentVideoVimeoId && (
                          <VimeoPlayer
                            videoId={
                              isAfterVideoVimeo
                                ? afterVideoVimeoId
                                : currentVideoVimeoId
                            }
                            onVideoEnd={handleVideoEnd}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="dashboard-title replay-video-section">
                  <h5>{message && <h3>{message}</h3>}</h5>
                  {showReplay && (
                    <button
                      className="replay-video"
                      onClick={handleReplay}
                      style={{ margin: "10px", padding: "10px" }}
                    >
                      🔄 Replay Video
                    </button>
                  )}

                  {/* Thank You Message */}
                  {quizCompleted && (
                    <div className="col-xxl-12 col-md-12">
                      <h3>🎉 Thank you for completing the quiz!</h3>
                      <p>
                        You will get all your winning certificates in your email
                        inbox soon.
                      </p>
                      <Link to={`/certificates`}>
                        <p>Click here to view all your winning certificates</p>
                      </Link>
                    </div>
                  )}
                  {isRetakeComplete && (
                    <div className="col-xxl-12 col-md-12">
                    <h3>🎉 Thank you for Retake the course!</h3>
                    <Link to={`/school-dashboard`}>
                      <p>Click here to Back Home</p>
                    </Link>
                  </div>
                  )}
                </div>

                <div className="row">
                  {!quizCompleted && showQuestion && currentQuestion && (
                    <div className="col-xxl-12 col-md-12 d-flex">
                      <div className="course-box flex-fill">
                        <div className="product teacher-quiz-product">
                          <h4 style={{ color: "green" }}>
                            {currentQuestion.bonusQuestion
                              ? "Bonus Question*"
                              : ""}{" "}
                          </h4>
                          <h5>
                            {currentGroup?.group} -{" "}
                            {currentQuestion.questionText}{" "}
                          </h5>
                          {currentQuestion.options.map((option, index) => (
                            <label key={index}>
                              {/* Adding key to the label */}
                              <input
                                type="checkbox"
                                name={option.text} // Or any other unique identifier
                                checked={selectedOptions[option.text] || false}
                                style={{ margin: "10px", padding: "10px" }}
                                onChange={handleCheckboxChange}
                                disabled={answerSelected}
                              />
                              {option.text}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showIsContinue && !retakeVideoId && (
        <div className="position-absolute testFromStartButtonCard">
          <div className="testFromStartButtonText">
            <p className="testFomStartButtonTextItem">
              Do you want to start as New or Continue?
            </p>
          </div>
          <div className="d-flex testFromStartButtonPair">
            <button onClick={handleRestartProcess}>Start as New</button>
            <button onClick={() => setShowIsContinue(false)}>Continue</button>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherTest;
